import React from 'react';
import { waLink } from '../App';

export default function Footer() {
  const colHead = { fontFamily:'var(--sans)', fontSize:12, letterSpacing:2, textTransform:'uppercase', color:'#c9a9b6', margin:'0 0 14px', fontWeight:700 };
  const link = { display:'block', color:'#e9d4cd', fontSize:15, marginBottom:9, transition:'color .2s', textDecoration:'none' };

  return (
    <footer style={{ background:'var(--plum-deep)', color:'#e9d4cd', padding:'60px 0 30px' }}>
      <div style={{ maxWidth:1180, margin:'0 auto', padding:'0 26px' }}>
        <div style={{ display:'flex', justifyContent:'space-between', gap:36, flexWrap:'wrap', alignItems:'flex-start' }}>
          <div>
            <div style={{ display:'flex', alignItems:'center', gap:13 }}>
              <img src="/assets/kreme-tops-logo.jpg" alt="Kreme Tops Bakery"
                style={{ width:50, height:50, borderRadius:'50%', border:'1.5px solid rgba(255,255,255,.25)', objectFit:'cover', objectPosition:'50% 30%' }} />
              <span>
                <span style={{ fontFamily:'var(--serif)', fontSize:27, color:'#fff', lineHeight:.9, display:'block' }}>Kreme Tops</span>
                <span style={{ fontSize:10, letterSpacing:3, textTransform:'uppercase', color:'#c9a9b6' }}>Bakery</span>
              </span>
            </div>
            <div style={{ fontFamily:'var(--serif)', fontStyle:'italic', fontSize:21, color:'#f0d9d0', maxWidth:'30ch', marginTop:16 }}>
              Every cake tells a story. Let's tell yours.
            </div>
          </div>

          <div>
            <h4 style={colHead}>Explore</h4>
            {[['#story','Our story'],['#gallery','Gallery'],['#bake','What we bake'],['#menu','Menu']].map(([href,label]) => (
              <a key={href} href={href} style={link}
                onMouseOver={e => e.currentTarget.style.color='#fff'}
                onMouseOut={e => e.currentTarget.style.color='#e9d4cd'}>{label}</a>
            ))}
          </div>

          <div>
            <h4 style={colHead}>Say hello</h4>
            <a href={waLink("Hi Kreme Tops!")} target="_blank" rel="noopener noreferrer" style={link}
              onMouseOver={e => e.currentTarget.style.color='#fff'} onMouseOut={e => e.currentTarget.style.color='#e9d4cd'}>
              WhatsApp · +254 748 391 815
            </a>
            <a href="https://instagram.com/kreme_tops.bakery" target="_blank" rel="noopener noreferrer" style={link}
              onMouseOver={e => e.currentTarget.style.color='#fff'} onMouseOut={e => e.currentTarget.style.color='#e9d4cd'}>
              Instagram · @kreme_tops.bakery
            </a>
            <a href="https://tiktok.com/@kreme_tops.bakery" target="_blank" rel="noopener noreferrer" style={link}
              onMouseOver={e => e.currentTarget.style.color='#fff'} onMouseOut={e => e.currentTarget.style.color='#e9d4cd'}>
              TikTok · @kreme_tops.bakery
            </a>
            <div style={{ color:'#e9d4cd', fontSize:15, marginBottom:9 }}>Nairobi, Kenya</div>
          </div>
        </div>

        <div style={{ borderTop:'1px solid rgba(255,255,255,.14)', marginTop:44, paddingTop:22, display:'flex', justifyContent:'space-between', flexWrap:'wrap', gap:10, fontSize:13, color:'#c9a9b6' }}>
          <span>© 2026 Kreme Tops Bakery</span>
          <span>Made by hand · iced with love</span>
        </div>
      </div>
    </footer>
  );
}
